import { useQueryClient } from "@tanstack/react-query";
import { useProductType } from "@lending/hooks/useProductType";
import { useApi } from "@lending/lib/api";

function useCreateApplicationApplicantDetailsQuery() {
  const $api = useApi();
  const queryClient = useQueryClient();
  const productType = useProductType();

  const applicationQueryKeyByProductType = {
    "personal-loan": ["get", "/v2/lending/personal_loan_applications/{uuid}/"],
    "credit-card": ["get", "/v2/lending/credit_card_applications/{uuid}/"],
    "auto-loan": ["get", "/v2/lending/vehicle_loan_applications/{uuid}/"],
  } as const;

  return $api.useMutation("post", "/v2/lending/application_applicant_details/", {
    // Adding an applicant changes both the details list and the application's
    // `additional_applicants`. Await the refetches so `mutateAsync` resolves only once
    // both caches are fresh: callers navigate on success, and the next screen reads the
    // co-applicant's name straight out of them.
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["get", "/v2/lending/application_applicant_details/"],
      });

      if (productType) {
        await queryClient.invalidateQueries({
          queryKey: applicationQueryKeyByProductType[productType],
        });
      }
    },
  });
}

export { useCreateApplicationApplicantDetailsQuery };
